import React from 'react';

import { ReactProps } from '../../../typings/common-types';

import Icon, { IIcon } from './icon';

const svg = (props: ReactProps) => (
  <svg viewBox="0 0 166 124" xmlns="http://www.w3.org/2000/svg" fill="currentColor" {...props}>
    <path d="M83 .172C37.696.172.865 36.856.865 81.978c0 13.26 3.285 26.35 9.337 38.06 1.21 2.412 3.631 3.79 6.225 3.79 1.038 0 2.248-.172 3.285-.861 3.459-1.723 4.67-6.028 2.94-9.473-5.015-9.644-7.781-20.666-7.781-31.516 0-37.372 30.606-67.856 68.129-67.856s68.13 30.484 68.13 67.856c0 11.022-2.767 22.044-7.782 31.516-1.73 3.445-.519 7.578 2.94 9.473 3.458 1.722 7.608.516 9.51-2.928 6.225-11.539 9.337-24.8 9.337-38.061C165.135 36.856 128.305.172 83 .172z" />
    <path d="M116.373 41.161L74.008 67.34c-5.187 3.272-8.3 8.955-8.3 14.983.173 9.645 7.954 17.395 17.638 17.222 6.052 0 11.758-3.272 14.87-8.61l25.42-42.712c2.939-4.65-2.421-9.989-7.263-7.06z" />
    <ellipse cx="83" cy="30.483" rx="7.435" ry="7.406" />
    <circle cx="46.542" cy="45.503" r="7.42" transform="rotate(-45 46.542 45.503)" />
    <ellipse cx="31.471" cy="81.806" rx="7.435" ry="7.406" />
    <ellipse cx="134.702" cy="81.978" rx="7.435" ry="7.406" />
  </svg>
);

const IconMotorDashboard = (props: IIcon & ReactProps) => <Icon {...props} svg={svg} />;

export default IconMotorDashboard;
